module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAPCAYAAAARZmTlAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAD1SURBVDhPrZMBDYMwFESRgAQkIGES5mBIwAE4GA42B0hAwiRMwiSwu/YopS0BAi/5yfbv/7u16bJxHBvUD/VB5dkFwOchzy+qYMPndBD2GeDTsjnYz45B84fBbmktFlQUChSP5fPS3m6wQx9ekU8r2Q2EQY3kTTCb2p8DJtBM/ZLNIMykAjrJMRB5p2FQLTkCWo4KA3rJ62CosrMLHpId6DGAr9Fn/+vEYG1WltwkG/C9t20HT1RI3gcWWrM6w2sspT1NZ+Z4wAQWwyCaXRcwAYPOWKVxpzsNjN7GMuaukfPALPWSKsnXAVMG8UXxilb/OzFZ9gcR3jXY+qR3sgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/image/header/down_arrow.png
// module id = 118
// module chunks = 0